import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import { createApolloFetch } from 'apollo-fetch';
import { gql } from 'apollo-boost';

import ProfileStringth from '../company-profile/company-profile-strength.component';
import ExplorePremium from '../explore-premium/explore-premium-component';
import Articles from '../../recommended-articles/recommended-articles.component';
import JobPosts from './job-posts.component';
import {url} from '../../../url';
import {JOB_STATUS ,GET_JOB} from './apis';


// styles , images and icons
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import { Paper, Button } from '@material-ui/core';
// this component represents jobs page 
class Jobs extends Component {
    constructor() {
        super();
        this.state = []
    }
    fetchJobs = () => {
        if (localStorage.jwt) {
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = url;
            let id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });

            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;
                next();
            });
            // get job status
            apolloFetch({
                query: JOB_STATUS,
            }).then(res => {
                if(res.data.jobStatuses){
                    let jobStatus = res.data.jobStatuses;
                    // get live jobs
                    apolloFetch({
                        query: GET_JOB,
                        variables : {
                            job_status_id : jobStatus[0].id
                        }
                    }).then(res => {
                        if(res.data.me.companyAuth.jobsGet){
                            this.setState({...this.state , liveJobs : res.data.me.companyAuth.jobsGet })
                        }
                    }).catch((err) => console.log(err));

                    // get past job
                    apolloFetch({
                        query: GET_JOB,
                        variables : {
                            job_status_id : jobStatus[1].id
                        }
                    }).then(res => {
                        if(res.data.me.companyAuth.jobsGet){
                            this.setState({...this.state , closedJobs : res.data.me.companyAuth.jobsGet})
                        }
                    }).catch((err) => console.log(err));
                }
            }).catch((err) => console.log(err));
             // get darft job
             apolloFetch({
                query: GET_JOB,
                variables : {
                    is_Draft : true
                }
            }).then(res => {
                if(res.data.me.companyAuth.jobsGet){
                    this.setState({...this.state , draftJobs : res.data.me.companyAuth.jobsGet })
                }
            }).catch((err) => console.log(err));
        }
    }
    componentDidMount(){
       this.fetchJobs()
    }
    callBack = (data) => {
        if(data === "update"){
            this.fetchJobs();
        }
    }
    render() {

        return (
            <div>
                <Container className="pt-5 pb-4">
                    <Row>
                        <Col md={8} className="p-0">
                            <Container>
                                <Paper className="p-3 mb-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                                    <Row className="m-0 mb-3 align-items-center justify-content-center">
                                        {/* profile image */}
                                        <Col md={8} className="text-left">
                                            <div>
                                                <h5>Company Jobs</h5>
                                                <p>All your jobs in one place</p>
                                            </div>
                                        </Col>
                                        <Col md={4} className="text-right">
                                            <Link to="/createJob">
                                                <Button
                                                    onClick={e=>
                                                        localStorage.setItem('updatedJobPost','')
                                                    }
                                                    size="large"
                                                    varient="continued"
                                                    className="btn-orange-gradiant pr-4 pl-4 "
                                                >
                                                    Add New</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Paper>
                                <Tab.Container className="" defaultActiveKey="first">
                                    <Row className="m-0 mb-3">
                                        <Col sm={12} className="mb-2 p-0">
                                            <Nav variant="pills" id="left-tabs-example">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="first" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                        <h6>Live Jobs</h6>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="second" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                        <h6>Past Jobs</h6>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="third" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                        <h6>Draft Jobs</h6>
                                                    </Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </Col>
                                        <Col sm={12} id="tab-content-container" className="p-0">
                                            <Tab.Content>
                                                <Tab.Pane eventKey="first">
                                                    <JobPosts callBack={this.callBack} data={this.state.liveJobs?this.state.liveJobs : ''} type="liveJobs"/>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="second" >
                                                    <JobPosts callBack={this.callBack} data={this.state.closedJobs?this.state.closedJobs : ''} type="closedJobs"/>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="third" >
                                                    <JobPosts callBack={this.callBack} data={this.state.draftJobs?this.state.draftJobs : ''} type="draftJobs"/>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Col>
                                    </Row>
                                </Tab.Container>
                            </Container>
                        </Col>
                        <Col md={4} className="p-0">
                            <Container fluid>
                                <ProfileStringth />
                                <ExplorePremium />
                                <Articles />
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}


export default withRouter(Jobs);